module.exports = __webpack_public_path__ + "static/media/kw-left-bg.9072c9b2.jpg";